import { render, staticRenderFns } from "./event-detail-title.vue?vue&type=template&id=5e91058c&scoped=true&"
import script from "./event-detail-title.vue?vue&type=script&lang=js&"
export * from "./event-detail-title.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-title.vue?vue&type=style&index=0&id=5e91058c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e91058c",
  null
  
)

export default component.exports